import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Activity, Newspaper, ChevronRight } from "lucide-react";

// Shown instead of TrendingConversationsPanel + FollowedJournalistsPanel
// (2026-08-30) when BOTH are empty. Each of those ships its own full
// "icon circle + heading + padding + CTA" empty state, which is fine when
// only one is empty -- but stacked together (as happens for every low-
// activity account today) they read as a wall of near-identical "nothing
// here yet" cards, not a clean layout. This folds both into one compact
// card with one-line rows instead. Reuses the same i18n keys the two full
// panels already use, so no new copy/translation surface is introduced.
const SocialDiscoveryEmptyState = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="bg-cream-100 dark:bg-slate-900/60 border border-cream-300 dark:border-slate-800/60 rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <Activity className="w-4 h-4 text-orange-600 dark:text-orange-400 flex-shrink-0" />
        <span className="text-sm text-gray-600 dark:text-slate-400">
          {t('dashboard.trendingConversations.noTrendingDiscussions')}
        </span>
      </div>

      <div className="h-px bg-cream-200 dark:bg-slate-800/60 my-3" />

      <button
        type="button"
        onClick={() => navigate('/news')}
        className="w-full flex items-center justify-between gap-3 group"
      >
        <span className="flex items-center gap-2 min-w-0">
          <Newspaper className="w-4 h-4 text-violet-600 dark:text-violet-400 flex-shrink-0" />
          <span className="text-sm text-gray-600 dark:text-slate-400 truncate">
            {t('dashboard.followedJournalists.emptyMessage')}
          </span>
        </span>
        <span className="text-xs text-blue-600 dark:text-blue-400 group-hover:text-blue-700 dark:group-hover:text-blue-300 flex items-center gap-0.5 flex-shrink-0 transition-colors">
          {t('dashboard.followedJournalists.browseNews')}
          <ChevronRight className="w-3.5 h-3.5" />
        </span>
      </button>
    </div>
  );
};

export default SocialDiscoveryEmptyState;
